import React from "react";
import styled from "styled-components";

import Title from "../atoms/Title";

interface IProps {
  title: string;
  content: React.ReactElement<HTMLElement>;
}
const Modal: React.FC<IProps> = ({ title, content, ...props }) => (
  <OutWrapper {...props}>
    <Container>
      <ModalTitle level={"h2"}>{title}</ModalTitle>
      <Content>{content}</Content>
    </Container>
  </OutWrapper>
);

export default Modal;

const OutWrapper = styled.div`
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 2;
`;
const Content = styled.div`
  padding: 30px;
`;
const ModalTitle = styled(Title)`
  height: 65px;
  padding: 0;
  vertical-align: middle;
  background-colro: red;
  margin-bottom: 0px;
`;
const Container = styled.div`
  text-align: center;
  width: 800px;
  height: fit-content;
  background-color: white;
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  border-radius: 2px;
`;
